import { Typography } from '@mui/material';
import type { CrmActivityDomain } from '@otw/models/leads/contacts';
import React from 'react';
import {
  CRM_ACTIVITY_DOMAIN_ACCENT,
  CRM_ACTIVITY_DOMAIN_LABEL,
} from '../util/activityDomainPaperSx';

/** Compact text label pinned to the bottom-right of an activity card. */
export const ActivityDomainLabel: React.FC<{
  domain: CrmActivityDomain | null | undefined;
}> = ({ domain }) => {
  if (!domain) return null;
  const accent = CRM_ACTIVITY_DOMAIN_ACCENT[domain];
  return (
    <Typography
      component="span"
      variant="caption"
      sx={{
        position: 'absolute',
        right: 10,
        bottom: 8,
        fontWeight: 800,
        fontSize: 10.5,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
        color: accent,
        lineHeight: 1,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {CRM_ACTIVITY_DOMAIN_LABEL[domain]}
    </Typography>
  );
};

export default ActivityDomainLabel;
